class CollectionSlider extends HTMLElement {
  constructor() {
    super();

    this.productCards = this.querySelectorAll('.product-card-wrapper');
    this.delay = parseInt(this.getAttribute('delay') || 3000);

    this.startInterval = this.startInterval.bind(this);
    this.stopInterval = this.stopInterval.bind(this);
  }

  connectedCallback() {
    this.preloadNextImage();
    this.startInterval();

    this.addEventListener('mouseenter', this.stopInterval);
    this.addEventListener('mouseleave', this.startInterval);
  }

  disconnectedCallback() {
    this.stopInterval();
    this.removeEventListener('mouseenter', this.stopInterval);
    this.removeEventListener('mouseleave', this.startInterval);
  }

  startInterval() {
    this.interval = setInterval(() => {
      const visibleProductCard = this.querySelector('.product-card-wrapper:not(.hidden)');
      const nextProductCard = visibleProductCard.nextElementSibling || this.querySelector('.product-card-wrapper');

      visibleProductCard.classList.add('hidden');
      nextProductCard.classList.remove('hidden');

      this.preloadNextImage();

    }, this.delay);
  }

  stopInterval() {
    clearInterval(this.interval);
  }

  preloadNextImage() {
    const visibleProductCard = this.querySelector('.product-card-wrapper:not(.hidden)');
    const nextProductCard = visibleProductCard.nextElementSibling || this.querySelector('.product-card-wrapper');
    const img = nextProductCard.querySelector('img');

    if (img) {
      img.setAttribute('loading', 'eager');
    }
  }
}

customElements.define('collection-slider', CollectionSlider);